import React from 'react'


const CBSteps = ({children, page=2,onPageChanged=(num => console.log(num)),mobile=false}) => {
//   const [currentPage,setCurrentPage] = useState(page)
  
    return <div>
        
    <div className="grid grid-cols-1">
      {
          React.Children.map(children, (child,i) => {
              const num = i
              if(mobile && (num) >= page) {
                return null // Return null if mobile and condition met
              }
              // Check if child is a valid React element before cloning
              if (!React.isValidElement(child)) {
                return child; // Return null/false/etc. children as is
              }
            return React.cloneElement(child, {
              currentSelection: page,
              index: num,
              onClick: (e =>
                {
                    // setCurrentPage(num)
                    onPageChanged(num)
                }
                )
            });
          })
        }
      </div>
      </div>
  }

  export { CBSteps }
